import { ReactElement } from "react";
import { TranslatorFunction } from "@avinet/adaptive-ui-translate/useTranslate";
import { BACKEND_URL } from "../../config/config";
import { InputSection, InputSectionType } from "../../types/Section";
import { formatDate } from "../../utils/date";
import { getRatingLabel } from "./ResultsTable";

export function formatValue(
  section: InputSection,
  value: any,
  t: TranslatorFunction,
  sessionToken?: string | null
): ReactElement | string {
  if (section.type === InputSectionType.boolean)
    return !!value ? t("yes") : t("no");

  if (value === undefined || value === null) return "";

  switch (section.type) {
    case InputSectionType.date:
      return formatDate(value);

    case InputSectionType.decimal:
      return (value as number).toLocaleString(undefined, {
        minimumFractionDigits: 2,
      });

    case InputSectionType.integer:
      return (value as number).toLocaleString();

    case InputSectionType.rating:
      return getRatingLabel(section.symbol, value, section.max ?? 5);

    case InputSectionType.multiselect_list:
      return value.replace(/,/g, ", ");

    case InputSectionType.media: {
      if (!value) return "";
      const src =
        BACKEND_URL +
        `WebServices/generic/Media.asmx/Download?uuid=${value}${
          sessionToken ? `&gm_session_id=${sessionToken}` : ""
        }`;
      return (
        <a
          href={`${src}&thumnail_size=large`}
          target="_blank"
          rel="noreferrer"
          title={t("openImage")}
        >
          <img src={`${src}&thumnail_size=small`} width={100} alt="" />
        </a>
      );
    }
  }

  return value.toString();
}
